import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const SearchBar = ({ onSearch, isLoading }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="cine-search-wrapper">
      <div className="cine-search">
        <FaSearch className="cine-search-icon" />
        <input
          type="text"
          placeholder="Search movies, series, episodes..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search movies"
        />
        <button
          type="submit"
          className="cine-search-btn"
          disabled={isLoading || !query.trim()}
        >
          {isLoading ? (
            <>
              <div className="spinner" />
              Searching
            </>
          ) : (
            <>
              <FaSearch size={14} />
              Search
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
